import { Grid } from '@material-ui/core';
import { Typography } from '@nutrien/cxp-components';
import React from 'react';

import useStyles from './StatusLabel.styles';
interface Props {
  taskStatusId?: number;
  inspectionStatusId?: number;
  workPackageId?: number;
  customClass: string;
  label: string;
}

const StatusLabel: React.FC<Props> = ({
  taskStatusId,
  inspectionStatusId,
  workPackageId,
  customClass,
  label,
}) => {
  const classes = useStyles({ taskStatusId, inspectionStatusId, workPackageId });
  return (
    <>
      <Grid className={classes.statusLabelGrid}>
        <Typography variant="subtitle1" className={customClass}>
          {label}
        </Typography>
      </Grid>
    </>
  );
};

export default StatusLabel;
